// still.js — still(): what moves on the screen stops; the sound plays on.
// -----------------------------------------------
// hush() for the eye (Ctrl+, in the live console, as Ctrl+. is hush()):
// every animation stops where it has got to (as rotate(off:1) stops one),
// every text() goes -- what stay:1 left painted too -- and the console's
// trig: lines that draw stop watching, so nothing new comes in on the beat.
// A sound's trig: line plays on; hush() is for those.
// still(all) (Ctrl+Shift+,) the screen back to plain as well: screen(off),
// every viz()'s own effects off (kaleido, blur, warp ...), the trails wiped.
// That is the "stage" reset (teardown.js): each of those modules registers
// its own stop, so still(all) knows no list.

import { stopAllAnimations } from "./animation.js";
import { stopAllCueTexts } from "./text.js";
import { dropDrawingTriggers } from "../control/signalTriggers.js";
import { stopAllStrobes } from "./strobe.js";
import { runReset } from "../system/teardown.js";

export function handleStillCue(ast) {
  if (ast?.args?.some(a => a.type === "all")) { runReset("stage"); return; }
  dropDrawingTriggers();
  stopAllCueTexts();
  stopAllAnimations();
  stopAllStrobes();          // the flashing too (imported, not loaded on demand: a strobe started just after must not be stopped by this late)
}
